import React from 'react';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import KycOverview from './KycOverview';
import KycTable from './KycTable';

const KycCompliance = () => {
  return (
    <Page title='Logirate | KYC Compliance'>
      <PageLayout>
        <Container>
          <KycOverview />
          <KycTable />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default KycCompliance;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
